import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export var LANG_LABEL_BY_KEY = {
  es: 'SPANISH',
  pt: 'PORTUGUESE',
  en: 'ENGLISH'
};
export var DEFAULT_VIDEO_ENDING_DURATION = 5;
/**
 * If the video is not loaded after this amount of seconds, the error state will be activated.
 */
export var VIDEO_LOAD_TIMEOUT = 120;
export var VIDEO_LOAD_TIMEOUT_ERROR_MESSAGE = /*#__PURE__*/"Video was not loaded within the ".concat(VIDEO_LOAD_TIMEOUT, "s timeout.");
export var DEFAULT_HLS_CONFIG = {
  debug: false,
  maxBufferLength: 3,
  maxBufferSize: 1 * 1024 * 1024
};
export var DEFAULT_ASPECT_RATIO = '16:9';
export var breakpointWidths = {
  xxs: 0,
  xs: 500,
  sm: 600,
  md: 800,
  lg: 1024
};
export var breakpointHeights = {
  xxs: breakpointWidths.xxs * 9 / 16,
  xs: breakpointWidths.xs * 9 / 16,
  sm: breakpointWidths.sm * 9 / 16,
  md: breakpointWidths.md * 9 / 16,
  lg: breakpointWidths.lg * 9 / 16
};
export var breakpoints = {
  xxs: /*#__PURE__*/"".concat(breakpointWidths.xxs, "px"),
  xs: /*#__PURE__*/"".concat(breakpointWidths.xs, "px"),
  sm: /*#__PURE__*/"".concat(breakpointWidths.sm, "px"),
  md: /*#__PURE__*/"".concat(breakpointWidths.md, "px"),
  lg: /*#__PURE__*/"".concat(breakpointWidths.lg, "px")
};
export var subtitleXR = {
  xxs: 6.5,
  xs: 3.3,
  sm: 3.3,
  md: 2.4,
  lg: 2
};
export var SUBTITLE_LINE_HEIGHT_RATIO = 1.3;
export var BOTTOM_CONTROLS_HEIGHT = {
  xxs: 60,
  xs: 72,
  sm: 96,
  md: 76,
  lg: 76
};
export var SUBTITLES_BOTTOM_SPACING = {
  xxs: 8,
  xs: 16,
  sm: 24,
  md: 24,
  lg: 24
};

// 1 hour
export var DEFAULT_IDLE_TIME = 1 * 60 * 60 * 1000;
export var VIDEO_MIME_TYPES = {
  HLS: 'application/x-mpegurl',
  WEBM: 'video/webm',
  OGG: 'video/ogg',
  MP4: 'video/mp4',
  '3GP': 'video/3gp'
};
export var VIDEO_SPEEDS = [{
  label: '0.25X',
  value: 0.25
}, {
  label: '0.5X',
  value: 0.5
}, {
  label: '0.75X',
  value: 0.75
}, {
  label: '1X',
  value: 1
}, {
  label: '1.25X',
  value: 1.25
}, {
  label: '1.5X',
  value: 1.5
}, {
  label: '1.75X',
  value: 1.75
}, {
  label: '2X',
  value: 2
}];
export var VIDEO_SPEEDS_BY_VALUE = /*#__PURE__*/VIDEO_SPEEDS.reduce(function (map, option) {
  return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, option.value, option));
}, {});
var KEY_CODES = {
  SPACE: 'Space',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  M: 'KeyM',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  F: 'KeyF',
  A: 'KeyA'
};
export var KEY_NAME_BY_ACTION = {
  TOGGLE_PLAY: 'SPACE',
  VOLUME_UP: 'ARROW_UP',
  VOLUME_DOWN: 'ARROW_DOWN',
  TOGGLE_MUTE: 'M',
  BACKWARD: 'ARROW_LEFT',
  FORWARD: 'ARROW_RIGHT',
  TOGGLE_FULLSCREEN: 'F',
  ADD_NOTE: 'A'
};
export var KEY_CODES_BY_ACTION = {
  TOGGLE_PLAY: KEY_CODES.SPACE,
  VOLUME_UP: KEY_CODES.ARROW_UP,
  VOLUME_DOWN: KEY_CODES.ARROW_DOWN,
  TOGGLE_MUTE: KEY_CODES.M,
  BACKWARD: KEY_CODES.ARROW_LEFT,
  FORWARD: KEY_CODES.ARROW_RIGHT,
  TOGGLE_FULLSCREEN: KEY_CODES.F,
  ADD_NOTE: KEY_CODES.A
};
export var REMAINING_SECONDS_TO_SKIP = 15;
export var REMAINING_SECONDS_TO_IDLE_SCREEN = 3;
export var NOTIFICATION_AUDIO_URL = 'https://static.crehana.com/static/files/Notification.mp3';
export var CUSTOM_GENERATEAI = [{
  label: 'CUSTOM_GENERATE_AI'
}, {
  label: 'CUSTOM_GENERATE_AI1'
}, {
  label: 'CUSTOM_GENERATE_AI2'
}];
export var IS_FIRST_OPENED_AI = 'isFirstOpenedAI';
export var IS_FIRST_OPENED_SKIP_AI = 'isFirstOpenedSkipAI';
export var IS_RENDER_AI = 'isRenderAI';
export var CUSTOM_AI = {
  error: {
    title: 'AI_ERROR_TITLE',
    subtitle: 'AI_ERROR_SUBTITLE',
    type: 'error'
  },
  success: {
    title: 'AI_SUCCESS_TOAST_TITLE',
    subtitle: 'AI_SUCCESS_TOAST_SUBTITLE',
    type: 'error'
  }
};